module.exports = __webpack_public_path__ + "static/img/packBack2.b99ffdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/packBack2.jpg
// module id = 940i
// module chunks = 0